import React from "react";

class Main extends React.Component {
  render() {
    return (
      <div>
        <div id="main">
          <div className="intro">
            <h2>A wide range of services!</h2>
          </div>
          <div className="text">
            <span>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Id,
              accusamus, ipsum nam delectus minima, iusto fuga dolor tempore
              accusantium consequuntur sapiente quibusdam facilis expedita quia
              et soluta ut dicta laudantium natus repellat eius at
              necessitatibus recusandae? Dolore, iure, architecto iste accusamus
              quidem omnis nihil possimus eaque corporis ullam fugiat harum.
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default Main;
